<template>
  <table class="table-mini">
    <thead>
      <TableCellHeading
        v-if="$slots.heading1"
        :style="widthHeading1 ? `min-width: ${widthHeading1}; width: ${widthHeading1};` : ''"
      >
        <slot name="heading1" />
      </TableCellHeading>
      <TableCellHeading
        v-if="$slots.heading2"
        :style="widthHeading2 ? `min-width: ${widthHeading2}; width: ${widthHeading2};` : ''"
      >
        <slot name="heading2" />
      </TableCellHeading>
      <TableCellHeading
        v-if="$slots.heading3"
        :style="widthHeading3 ? `min-width: ${widthHeading3}; width: ${widthHeading3};` : ''"
      >
        <slot name="heading3" />
      </TableCellHeading>
      <TableCellHeading
        v-if="$slots.heading4"
        :style="widthHeading4 ? `min-width: ${widthHeading4}; width: ${widthHeading4};` : ''"
      >
        <slot name="heading4" />
      </TableCellHeading>
    </thead>
    <tbody :class="{ unlimited: unlimitedLength }">
      <TableRow
        v-for="item in items"
        :key="item"
        tabindex="0"
        @click="emits('onClicked', item)"
        @keydown.enter="emits('onClicked', item)"
        @keydown.space="(event: Event) => handleSpaceKey(event, item)"
        @mousemove="emits('onHovered', item)"
      >
        <TableCellData
          v-if="$slots.value1"
          :style="widthValue1 ? `min-width: ${widthValue1}; width: ${widthValue1};` : ''"
        >
          <slot name="value1" :item="item" />
        </TableCellData>
        <TableCellData
          v-if="$slots.value2"
          :style="widthValue2 ? `min-width: ${widthValue2}; width: ${widthValue2};` : ''"
        >
          <slot name="value2" :item="item" />
        </TableCellData>
        <TableCellData
          v-if="$slots.value3"
          :style="widthValue3 ? `min-width: ${widthValue3}; width: ${widthValue3};` : ''"
        >
          <slot name="value3" :item="item" />
        </TableCellData>
        <TableCellData
          v-if="$slots.value4"
          :style="widthValue4 ? `min-width: ${widthValue4}; width: ${widthValue4};` : ''"
        >
          <slot name="value4" :item="item" />
        </TableCellData>
      </TableRow>
    </tbody>
  </table>
</template>
<script lang="ts" setup>
import TableCellHeading from '@/design-system/atoms/TableCellHeading.vue'
import TableCellData from '@/design-system/atoms/TableCellData.vue'
import TableRow from '@/design-system/atoms/TableRow.vue'

defineProps<{
  items: any[]
  widthHeading1?: string
  widthHeading2?: string
  widthHeading3?: string
  widthHeading4?: string
  widthValue1?: string
  widthValue2?: string
  widthValue3?: string
  widthValue4?: string
  unlimitedLength?: boolean
}>()
const emits = defineEmits<{
  (e: 'onClicked', item: any): void
  (e: 'onHovered', item: any): void
}>()

function handleSpaceKey(event: Event, item: any) {
  event.preventDefault() // Prevent space bar scrolling
  emits('onClicked', item)
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/mixins.scss';
@use '@/design-system/design-tokens/font-variables.scss';

.button-no-padding {
  padding: 0;
}
.table-mini {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  thead {
    align-items: center;
    background-color: rgba(variables.$color-primary-light, 0.4);
    display: flex;
    height: 32px;
    justify-content: space-between;
    padding: 0;
    width: 100%;
    th {
      padding: 4px;
      &:nth-child(2) {
        float: right;
        margin-left: auto;
      }
      &:last-child {
        justify-content: flex-end;
        padding-right: 8px;
      }
      &:not(:first-child) {
        justify-content: flex-end;
      }
    }
  }

  .unlimited {
    max-height: fit-content;
  }
  tbody {
    display: flex;
    flex-flow: column;

    max-height: calc(32px * 6); // Six rows
    overflow-x: hidden;
    overflow-y: auto;
    padding-right: 4px;
    width: 100%;
    @include mixins.scrollbar-vertical;
    tr {
      height: 32px;
      padding: 0;
      width: 100%;
      td {
        gap: 0;
        height: 32px;
        padding: 4px;
        @include font-mixins.desktop-regular-paragraph;
        &:first-child {
          max-width: 50%;
        }
        &:not(:first-child) {
          justify-content: flex-end;
        }
        &:nth-child(2) {
          margin-left: auto;
        }
        &:last-child {
          justify-content: flex-end;
          padding-right: 4px;
        }
      }
      &:hover:not(.selected) {
        background-color: rgba(205, 222, 254, 0.2);
        td {
          .list-group__button {
            background-color: rgba(205, 222, 254, 0.2);
          }
        }
      }
      &:last-child {
        border-radius: 0;
      }
      &:not(:first-child) {
        border-top: none;
      }
    }
  }
}
</style>
